import { Injectable } from "@angular/core";
import Swal from 'sweetalert2'; 
@Injectable({
  providedIn: "root"
})
export class ErrorHandlingService {

  constructor() {}

  checkError(err:any) {

    switch (err) {

      case 0: {
        Swal.fire("Server Down", "Try After Sometime", "warning");
        break;
      }
      case 400: {
        Swal.fire("Bad Request", "Try After Sometime", "warning");
        break;
      }
      case 500: {
        Swal.fire("Internal Server Error", "Try After Sometime", "warning");
        break;
      }
      case 404: {
        Swal.fire("File Not Found", "Try Again", "warning");
        break;
      }

    }

  }
}
